(function() {
    var m = angular.module('utils');
    /**
     * Чудесная директива, которая позволяет добавить прочерк/плейсхолдер
     * в select поле в которое привязана модель. Следит за моделью, и если
     * она была изменена, и была изменена не на пустую строку - убирает
     * опшен-плейсхолдер. Если была изменена на пустую строку - ставит плейсхолдер.
     * Плеисхолдер может быть установлен только один раз. Ну и убран соотвественно тоже.
     */
    m.directive('defnone', [function() {
        return {
            require: 'ngModel',
            priority: 10,
            link: function(scope, elm, attrs, ngModel) {

                var removed = false;
                var added = false;
                var placeholder = attrs.defnone ? attrs.defnone : '-';
                var placeholderEl = null;

                function addHolder() {
                    placeholderEl = $('<option>').val('').html(placeholder);
                    $(elm).prepend(placeholderEl);
                    $(elm).val('');
                }

                scope.$on('defnone-set', function() {
                    setTimeout(function() {
                        var phe = $(elm).find('option[value=""]');
                        if (ngModel.$modelValue === '' && phe.size() == 0) {
                            addHolder();
                        }
                    }, 0);
                });

                scope.$watch(function() {
                    return ngModel.$modelValue;
                }, function() {

                    if (removed) {
                        return;
                    }
                    if (ngModel.$modelValue == '') {
                        if (added) {
                            return;
                        }

                        addHolder();

                        added = true;
                    } else {
                        if (added) {
                            removed = true;
                            placeholderEl.remove();
                        }
                    }
                });



            }
        };
    }]);
})();
